import { z } from 'zod';

import { BankruptcyId, LosId } from '../../BrandedIds';
import { BankruptcyChapter } from '../../loan/Bankruptcy';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

export const ExportableBankruptcy = z
  .object({
    id: BankruptcyId,
    loanId: LosId,

    chapter: BankruptcyChapter,
    filedAt: zodTemporalPlainDate,
    endDate: zodTemporalPlainDate.optional(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Bankruptcy' });

export type ExportableBankruptcy = z.infer<typeof ExportableBankruptcy>;
